<template>
  <div class="login-modal-container" @click="close">
    <div class="box wechatSignin" @click.stop>
      <div class="qrCode pr" style="position: relative">
        <img
          v-show="!isImageLoading"
          :src="qrCodeData.url"
          alt=""
          class="qrCodeImg"
          @load="isImageLoading = false"
        />
        <span class="el-icon-loading" v-show="isImageLoading"></span>
        <img
          src="https://files.wondercv.com/auth/qrcode_reload.png"
          alt=""
          class="qrCodeReload pa cursor_p"
          @click="getMicroQrcode()"
          v-show="qrCodeData.checkSize < 1"
        />
      </div>
      <div class="msg"><i class="iconfont iconweixin"></i>使用微信扫码登录</div>
      <p class="login" @click="handleClickSignin">其他注册方式</p>
    </div>

    <LoginDevice
      :equipment-list="loginDeviceList"
      :equipment-dialog="loginDeviceVisible"
      @delEquipmentFn="removeLoginDevices"
      @login="addLoginDevice(jwtData)"
      @cancelFn="loginDeviceVisible = false"
    />
  </div>
</template>
<script>
import api from "@/api";
import { routerTo, returnBrowserFinger, updateJWT } from "@/assets/js/util";
import LoginDevice from "./loginDevice.vue";
import { checkUserMatch } from "@/assets/js/auth";

function generateUUID8() {
  return "xxxxxxxx".replace(/x/g, () => {
    return Math.floor(Math.random() * 16).toString(16);
  });
}
let qrCodeTimeoutName = null;

export default {
  components: {
    LoginDevice,
  },
  data() {
    return {
      isImageLoading: false,
      microSceneStr: "",
      loginFlag: true,
      qrCodeQuery: {
        // 获取二维码参数
        expire_seconds: 60, //二维码有效期
        scene_str: "", //场景值 {扫码业务}+{身份} 扫码业务：login 扫码业务(string):login 例如login_动态的uuid
        account_type: "cv_account", //账户种类 hr_account 或 cv_account
        operation_type: "login", //login/bind
      },
      qrCodeData: {
        //二维码参数
        url: "",
        checkSize: 57 / 3, // 轮训次数
        uuid: "",
      },
      jwtData: {},
      loginDeviceVisible: false,
      loginDeviceList: [],
    };
  },
  methods: {
    handleClickSignin() {
      routerTo("/auth-signin?type=phone");
    },
    hideBindQrcode() {
      this.showQrCode = false;
      this.qrCodeData = {
        //二维码参数
        url: "",
        checkSize: 57 / 3, // 轮训次数
      };
      clearInterval(qrCodeTimeoutName);
    },
    close(type) {
      this.hideBindQrcode();
      this.$emit("close", type);
    },
    async fetchLoginDeviceList() {
      try {
        const payload = {
          page: 1,
          page_size: 100,
        };
        const res = await api.Equipment.getCredibleEquipment(payload, {
          Authorization: this.jwtData.jwt,
        });

        if (res.code === 1000) {
          this.loginDeviceList = res.data.devices;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async removeLoginDevices(list) {
      try {
        const res = await api.Equipment.delCredibleEquipment(
          { device_numbers: list },
          {
            Authorization: this.jwtData.jwt,
          }
        );
        if (res.code === 1000) {
          this.$message.success("删除成功");
          this.fetchLoginDeviceList();
        } else {
          this.$message.error(res.message);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async addLoginDevice() {
      try {
        const finger = returnBrowserFinger();
        const res = await api.Equipment.addCredibleEquipment(finger, {
          Authorization: this.jwtData.jwt,
        });
        if (res.code === 1000) {
          this.loginFlag = false;

          qrCodeTimeoutName && clearInterval(qrCodeTimeoutName);
          qrCodeTimeoutName = null;

          const loginData = {
            ...this.jwtData,
            cookieEndTime: 14 * 24 * 60 * 60,
            jwt_timestamp:
              Math.floor(new Date().getTime() / 1000) + 14 * 24 * 60 * 60,
          };

          await updateJWT(loginData);

          if (this.jwtData.new_account) {
            // TODO: 新用户上报
          }

          await checkUserMatch();

          this.close("refresh");
        } else {
          clearInterval(qrCodeTimeoutName);
          qrCodeTimeoutName = null;
          await this.fetchLoginDeviceList();
          this.loginDeviceVisible = true;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getWechatScanResult() {
      try {
        const res = await api.auth.getWechatScanResult({
          scene_str: this.microSceneStr,
          operation_type: "login",
          account_type: "wechat_miniprogram",
        });
        if (res.code === 1000 && res.data.jwt) {
          if (this.loginFlag) {
            this.jwtData = res.data;
            this.addLoginDevice(res.data);
          }
        }
      } catch (error) {
        console.log(error, "getWechatScanResult error");
      }
    },
    //【微信】检测是否登录
    checkWechatLogin() {
      qrCodeTimeoutName = setInterval(() => {
        this.getWechatScanResult();
        this.qrCodeData.checkSize = this.qrCodeData.checkSize - 1;
        if (this.qrCodeData.checkSize < 1) {
          clearInterval(qrCodeTimeoutName);
          qrCodeTimeoutName = null;
        }
      }, 3000);
    },
    async getMicroQrcode() {
      try {
        this.microSceneStr = "";
        this.qrCodeData.url = "";
        this.qrCodeData.checkSize = 57 / 3;

        clearInterval(qrCodeTimeoutName);

        this.isImageLoading = true;
        const scene_str = `login_${generateUUID8()}`;
        this.microSceneStr = scene_str;
        this.qrCodeData.url = "";

        const res = await api.auth.getMicroCode({
          ...this.qrCodeQuery,
          account_type: "wechat_miniprogram",
          scene_str,
          env_version:
            process.env.NODE_ENV == "development"
              ? "trial"
              : process.env.ENV_VERSION,
        });

        if (res.code === 1000) {
          this.isImageLoading = false;
          this.qrCodeData.url = `data:image/png;base64,${res.data.body}`;
          //轮训倒计时
          this.qrCodeData.checkSize = 57 / 3;
          // 【微信】检测是否登录
          this.checkWechatLogin();
        } else {
          this.$message.error(res.message);
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.getMicroQrcode();
  },
};
</script>
<style scoped lang="scss">
.login-modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 101;
  .wechatSignin {
    width: 400px;
    height: 400px;
    text-align: center;
    border-radius: 6px;
    background-color: #fff;
    .login-tips {
      display: flex;
      align-items: center;
      position: absolute;
      top: 30px;
      left: 31%;
      width: fit-content;

      .tips-text {
        margin-left: 5px;
        color: #8a8a8a;
      }
    }
    .qrCode {
      width: 230px;
      height: 230px;
      padding-top: 25px;
      position: relative;
      margin: 40px auto 0;
      .qrCodeImg {
        display: block;
        width: 230px;
        height: 230px;
      }
      .qrCodeReload {
        position: absolute;
        left: 0px;
        top: 25px;
        display: block;
        width: 230px;
        height: 230px;
        cursor: pointer;
      }
    }
    .msg {
      font-size: 14px;
      color: #757575;
      margin-top: 20px;
      .iconfont {
        color: #00c05f;
        margin-right: 4px;
        font-size: 16px;
      }
    }
    .login {
      display: block;
      text-align: center;
      color: #a1a1a1;
      font-size: 13px;
      text-decoration: underline;
      margin-top: 20px;
      cursor: pointer;
    }
    .el-icon-loading {
      position: absolute;
      font-size: 32px;
      color: #bcbcbc;
      top: calc(50% - 16px);
      left: calc(50% - 16px);
    }
  }
}
</style>
